module.exports = __webpack_public_path__ + "img/team3.1471f414.png";